module.exports = __webpack_public_path__ + "static/media/guardarian.0cf66fe5.png";